module.exports = __webpack_public_path__ + "img/tv.19f3f258.svg";